import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { CgProfile } from 'react-icons/cg';
import { MdLogout, MdInsertChart, MdOutlineSavings, MdCardGiftcard } from 'react-icons/md';
import { readUser } from '@app/services/localStorage.service';
import {
  buildNavAccess,
  canViewMyBonus,
  canViewMyReport,
  canViewMySalary,
} from '@app/components/layouts/main/sider/navigationAccess';

interface MenuLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  danger?: boolean;
}

const MenuLink: React.FC<MenuLinkProps> = ({ to, icon, label, danger }) => (
  <Link
    to={to}
    className={clsx(
      'tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-font-medium tw-transition-colors',
      danger
        ? 'tw-text-error hover:tw-bg-error-container hover:tw-text-error'
        : 'tw-text-on-surface hover:tw-bg-surface-container-low hover:tw-text-primary',
    )}
  >
    <span className={clsx('tw-flex tw-text-[18px]', !danger && 'tw-text-primary')}>{icon}</span>
    {label}
  </Link>
);

export const ProfileOverlay: React.FC = React.memo(({ ...props }) => {
  // Cùng quy tắc với nhóm "Của tôi" ở sidebar → không hiện mục bấm vào là 403.
  const access = buildNavAccess(readUser());

  return (
    <div className="tw-flex tw-min-w-[210px] tw-flex-col tw-gap-0.5 tw-py-1" {...props}>
      {canViewMyReport(access) && <MenuLink to="/sales-dashboard" icon={<MdInsertChart />} label="Báo cáo của tôi" />}
      {canViewMySalary(access) && <MenuLink to="/my-salary" icon={<MdOutlineSavings />} label="Lương của tôi" />}
      {canViewMyBonus(access) && <MenuLink to="/my-bonus" icon={<MdCardGiftcard />} label="Bonus của tôi" />}
      <MenuLink to="/profile" icon={<CgProfile />} label="Hồ sơ cá nhân" />
      <div className="tw-mx-3 tw-my-1 tw-h-px tw-bg-outline-variant" />
      <MenuLink to="/logout" icon={<MdLogout />} label="Đăng xuất" danger />
    </div>
  );
});
